




















































































import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";

@Component({
	name: "quotation-preview",
	computed: {
		...mapState("auth", ["currentUser"]),
		...mapState("products", ["activeQuotation", "activeQuotationLoading"]),
		subtotal() {
			// @ts-ignore
			return this.activeQuotation.products.reduce(
				(a: any, p: any) => a + p.price * p.qty,
				0
			);
		},
	},
})
export default class QuotationPreview extends Vue {
	public currentUser!: any;
	public activeQuotation!: any;
	public activeQuotationLoading!: any;
}
